'use strict';

var SECONDARY_QUANTITY_SELECTOR = '.secondary-quantity';

/**
 *
 * @param {element} $input - to get product id and URL details.
 * @param {Integer} quantityVal - to update qty value in backend.
 */
function updateQuantity($input, quantityVal) {
    const _pid = $input.data('pid'),
    _url = $input.data('action');

    const _form = {
        pid: _pid,
        quantity: quantityVal
    }

    $.ajax({
        url: _url,
        type: 'POST',
        data: _form,
        error: function (err) {
            if (!err.responseJSON.loggedin && err.responseJSON.loginUrl) {
                $('body').trigger('signinModal:open', err.responseJSON.loginUrl);
            }
        }
    });
}

module.exports = {
    /**
     * Increase or decrease the quantity value based on + or - button clicks
     * @param {Boolean} isWishlist - To execute additional functionality for wishlist
     */
    updateQuantityValue: function(isWishlist) {
        $(document).on('blur', SECONDARY_QUANTITY_SELECTOR + ' .quantity', function () {
            const $this = $(this),
                $secondaryQty = $this.closest(SECONDARY_QUANTITY_SELECTOR),
                $minusBtn = $secondaryQty.find('.minus'),
                $plusBtn = $secondaryQty.find('.plus');
            let quantityVal = parseInt($this.val());

            $plusBtn.removeClass('hide');
            if (quantityVal <= 1 || $this.val() === '') {
                $this.val('1');
                quantityVal = 1;
                $minusBtn.removeClass('active');
            } else if (quantityVal > 1) {
                $minusBtn.addClass('active');
            }

            if(quantityVal >= 999) {
                $plusBtn.addClass('hide');
            } else if(isWishlist) {
                updateQuantity($this, quantityVal);
            }
        });

        $(document).on('click', SECONDARY_QUANTITY_SELECTOR + ' .plus', function () {
            const $this = $(this),
                $secondaryQty = $this.closest(SECONDARY_QUANTITY_SELECTOR),
                $minusBtn = $secondaryQty.find('.minus'),
                $input = $secondaryQty.find('.quantity');
            let quantityVal = parseInt($input.val());

            if (quantityVal < 1) {
                $input.val('1');
            } else {
                quantityVal = quantityVal + 1;
                $input.val(quantityVal);
                $minusBtn.addClass('active');
            }

            if (quantityVal >= 999) {
                $this.addClass('hide');
            }

            if (isWishlist) {
                updateQuantity($input, quantityVal);
            }
        });

        $(document).on('click', SECONDARY_QUANTITY_SELECTOR + ' .minus', function () {
            const $this = $(this),
                $secondaryQty = $this.closest(SECONDARY_QUANTITY_SELECTOR),
                $plusBtn = $secondaryQty.find('.plus'),
                $input = $secondaryQty.find('.quantity');
            let quantityVal = parseInt($input.val());

            if (quantityVal > 1 && quantityVal <= 999) {
                quantityVal = quantityVal - 1;
                $input.val(quantityVal);
                $plusBtn.removeClass('hide');
            }

            if (quantityVal <= 1) {
                $this.removeClass('active');
            }

            if (isWishlist) {
                updateQuantity($input, quantityVal);
            }
        });
    },

    /**
     * To display the quantity field buttons based on qty value
     * @param {Boolean} isWishlist - To add functionality only for wishlist
     */
    updateQuantityState: function(isWishlist) {
        if (isWishlist) {
            $('.wishlistItemCards ' + SECONDARY_QUANTITY_SELECTOR).each(function() {
                const $this = $(this),
                    $minus = $this.find('.minus'),
                    $quantity = $this.find('.quantity');
                const quantityVal = parseInt($quantity.val());
                if(quantityVal > 1) {
                    $minus.addClass('active');
                }
            });
        }
    }
}
